import { render } from "./EditCustomer.vue?vue&type=template&id=2db7c376&ts=true"
import script from "./EditCustomer.vue?vue&type=script&lang=ts"
export * from "./EditCustomer.vue?vue&type=script&lang=ts"

import "./EditCustomer.vue?vue&type=style&index=0&id=2db7c376&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__